const initialState = {
  currentUserRoles: [],
  currentLoggedInUserDetail: null,
  companyRoles: [],
  roles: [],
  permissions: [],
  users: [],
  loading: false,
  user: null,
  error: null,
  userDetailsLoading: false,
  updateLegalContentLoading: false,
  loginLoading: false,
  forgotPasswordLoading: false,
  forgotUsernameLoading: false,
  resendEmailLoading: false,
  updateUsernameLoading: false,
  updateUsernameSuccess: false,
  changePasswordLoading: false,
  changePasswordError: null,
  changeMyProfilePasswordLoading: false,
  changeMyProfilePasswordSuccess: false,
  changeMyProfilePasswordError: null,
  validateCurrentPasswordLoading: false,
  validateCurrentPasswordError: null,
  loginError: null,
  requiresMfa: false,
  sessionToken: null,
  userId: null,
  mfaVerifyLoading: false,
  mfaStatusLoading: false,
  mfaStatus: null,
  isAuthenticated: false,
  accessToken: null,
  userInfo: null,
  passwordChangeReminderDays: 0,
  userRolesLoading: false,
  userRoles: [],
  // System maintenance
  isSystemMaintenance: false,
  // Add new MFA setup fields
  isFirstTimeSetup: false,
  qrCodeImage: null,
  secretKey: null,
  // Add pharmacy stores state
  pharmacyStores: [],
  pharmacyStoresLoading: false,
  pharmacyStoresError: null,
  // Add signature upload state
  signatureUploadLoading: false,
  signatureUploadError: null,
  zendeskHelpCenterLoading: false,
  zendeskHelpCenterData: null,
  zendeskHelpCenterError: null,
  zendeskHelpCenterFetchAttempted: false,
    // Account lockout state
  isAccountLocked: false,
  accountLockedMessage: null,
  generateResetLinkLoading: false,
};

const usersReducers = (state = initialState, action) => {
  switch (action.type) {
    case "GET_USERS_SUCCESS":
      return { ...state, users: action.payload, loading: false, error: null };
    case "GET_USERS_FAILURE":
      return { ...state, users: [], loading: false, error: action.payload };
    case "GET_USER_SUCCESS":
      return { ...state, user: action.payload, loading: false, error: null };
    case "GET_USER_FAILURE":
      return { ...state, user: null, loading: false, error: action.payload };
    case "SET_USER_DETAILS_LOADING":
      return {
        ...state,
        userDetailsLoading: action.payload,
      };
    case "SET_CURRENT_USER_ROLES":
      return {
        ...state,
        currentUserRoles: action.payload,
      };
    case "SET_USER_ROLES_LOADING":
      return {
        ...state,
        userRolesLoading: action.payload,
      };
    case "GET_USER_ROLES_SUCCESS":
      return {
        ...state,
        userRoles: action.payload,
        userRolesLoading: false,
        error: null,
      };
    case "GET_USER_ROLES_FAILURE":
      return {
        ...state,
        userRoles: [],
        userRolesLoading: false,
        error: action.payload,
      };
    case "RESTORE_USER_ROLES_FROM_SESSION":
      return {
        ...state,
        userRoles: action.payload,
        userRolesLoading: false,
        error: null,
      };
    case "GET_CURRENT_USER_DETAILS_SUCCESS":
      return {
        ...state,
        currentLoggedInUserDetail: state.currentLoggedInUserDetail
          ? { ...state.currentLoggedInUserDetail, ...action.payload }
          : action.payload,
        userDetailsLoading: false,
        error: null,
      };
    case "GET_REELMEMBER_BY_ID_SUCCESS":
      return {
        ...state,
        currentLoggedInUserDetail: state.currentLoggedInUserDetail
          ? {
              ...state.currentLoggedInUserDetail,
              driverLicenceExpiry: action.payload.driverLicenceExpiry ?? state.currentLoggedInUserDetail.driverLicenceExpiry,
              secondaryGovernmentIDExpiry: action.payload.secondaryGovernmentIDExpiry ?? state.currentLoggedInUserDetail.secondaryGovernmentIDExpiry,
              secondaryGovernmentIDNumber: action.payload.secondaryGovernmentIDNumber ?? state.currentLoggedInUserDetail.secondaryGovernmentIDNumber,
              hipaaComplianceCertification: action.payload.hipaaComplianceCertification ?? state.currentLoggedInUserDetail.hipaaComplianceCertification,
              hippaCertificationExpiryDate: action.payload.hippaCertificationExpiryDate ?? state.currentLoggedInUserDetail.hippaCertificationExpiryDate,
              accessTools: action.payload.accessTools ?? state.currentLoggedInUserDetail.accessTools,
              accessToolsDateAdded: action.payload.accessToolsDateAdded ?? state.currentLoggedInUserDetail.accessToolsDateAdded,
              photo: action.payload.photo ?? state.currentLoggedInUserDetail.photo,
            }
          : state.currentLoggedInUserDetail,
      };
    case "GET_CURRENT_USER_DETAILS_FAILURE":
      return {
        ...state,
        currentLoggedInUserDetail: null,
        userDetailsLoading: false,
        error: action.payload,
      };
    case "SET_UPDATE_LEGAL_CONTENT_LOADING":
      return {
        ...state,
        updateLegalContentLoading: action.payload,
      };
    case "GET_ROLES_SUCCESS":
      return {
        ...state,
        roles: action.payload,
        loading: false,
        error: null,
      };
    case "GET_ROLES_FAILURE":
      return {
        ...state,
        roles: [],
        loading: false,
        error: action.payload,
      };
    case "GET_PERMISSIONS_SUCCESS":
      return {
        ...state,
        permissions: action.payload,
        loading: false,
        error: null,
      };
    case "GET_PERMISSIONS_FAILURE":
      return {
        ...state,
        permissions: [],
        loading: false,
        error: action.payload,
      };
    case "GET_COMPANY_ROLES_SUCCESS":
      return {
        ...state,
        companyRoles: action.payload,
        loading: false,
        error: null,
      };
    case "GET_COMPANY_ROLES_FAILURE":
      return {
        ...state,
        companyRoles: [],
        loading: false,
        error: action.payload,
      };
    case "SET_LOGIN_LOADING":
      return {
        ...state,
        loginLoading: action.payload,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        loginLoading: false,
        loginError: null,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        userInfo: action.payload.userInfo,
        requiresMfa: false,
        sessionToken: null,
        userId: null,
      };
    case "LOGIN_FAILURE":
      return {
        ...state,
        loginLoading: false,
        loginError: action.payload,
        isAuthenticated: false,
        accessToken: null,
        userInfo: null,
      };
    case "LOGIN_ACCOUNT_LOCKED":
      return {
        ...state,
        loginLoading: false,
        loginError: null,
        isAccountLocked: true,
        accountLockedMessage: action.payload?.message || 'Your account has been temporarily locked.',
      };
    case "CLEAR_ACCOUNT_LOCKED":
      return {
        ...state,
        isAccountLocked: false,
        accountLockedMessage: null,
      };
    case "SET_GENERATE_RESET_LINK_LOADING":
      return {
        ...state,
        generateResetLinkLoading: action.payload,
      };
    case "LOGIN_MFA_REQUIRED":
      return {
        ...state,
        loginLoading: false,
        loginError: null,
        requiresMfa: true,
        sessionToken: action.payload.sessionToken,
        userId: action.payload.userId,
        // Store MFA setup information
        isFirstTimeSetup: action.payload.isFirstTimeSetup || false,
        qrCodeImage: action.payload.qrCodeImage || null,
        secretKey: action.payload.secretKey || null,
        // account locked 
        isAccountLocked: false,
        accountLockedMessage: null,
      };
    case "SET_MFA_VERIFY_LOADING":
      return {
        ...state,
        mfaVerifyLoading: action.payload,
      };
    case "MFA_VERIFY_SUCCESS":
      return {
        ...state,
        loginError: null,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        userInfo: action.payload.userInfo,
        requiresMfa: false,
        sessionToken: null,
        userId: null,
        // Clear MFA setup information after successful verification
        isFirstTimeSetup: false,
        qrCodeImage: null,
        secretKey: null,
      };
    case "MFA_VERIFY_FAILURE":
      return {
        ...state,
        mfaVerifyLoading: false,
        loginError: action.payload,
      };
    case "SET_MFA_STATUS_LOADING":
      return {
        ...state,
        mfaStatusLoading: action.payload,
      };
    case "CHECK_MFA_STATUS_SUCCESS":
      return {
        ...state,
        mfaStatusLoading: false,
        mfaStatus: action.payload,
        loginError: null,
      };
    case "CHECK_MFA_STATUS_FAILURE":
      return {
        ...state,
        mfaStatusLoading: false,
        loginError: action.payload,
      };
    case "CLEAR_LOGIN_ERROR":
      return {
        ...state,
        loginError: null,
      };
    case "LOGOUT":
      return {
        ...state,
        isAuthenticated: false,
        accessToken: null,
        userInfo: null,
        requiresMfa: false,
        sessionToken: null,
        userId: null,
        loginError: null,
        passwordChangeReminderDays: 0,
        userRoles: [],
        currentUserRoles: [],
        // Clear MFA setup information on logout
        isFirstTimeSetup: false,
        qrCodeImage: null,
        secretKey: null,
        zendeskHelpCenterData: null,
        zendeskHelpCenterError: null,
        zendeskHelpCenterFetchAttempted: false,
      };
    case "SET_FORGOT_PASSWORD_LOADING":
      return {
        ...state,
        forgotPasswordLoading: action.payload,
      };
    case "SET_FORGOT_USERNAME_LOADING":
      return {
        ...state,
        forgotUsernameLoading: action.payload,
      };
    case "SET_RESEND_EMAIL_LOADING":
      return {
        ...state,
        resendEmailLoading: action.payload,
      };
    case "SET_PASSWORD_CHANGE_REMINDER":
      return {
        ...state,
        passwordChangeReminderDays: action.payload,
      };
    case "HIDE_PASSWORD_CHANGE_REMINDER":
      return {
        ...state,
        passwordChangeReminderDays: 0,
      };
    // Change password with token cases
    case "SET_CHANGE_PASSWORD_LOADING":
      return {
        ...state,
        changePasswordLoading: action.payload,
      };
    case "CHANGE_PASSWORD_FAILURE":
      return {
        ...state,
        changePasswordLoading: false,
        error: action.payload,
        changePasswordError: action.payload,
      };
    case "CLEAR_CHANGE_PASSWORD_ERROR":
      return {
        ...state,
        changePasswordError: null,
      };
    case "RESTORE_AUTH_FROM_SESSION":
      return {
        ...state,
        isAuthenticated: true,
        accessToken: action.payload.accessToken,
        userInfo: action.payload.userInfo,
        loginError: null,
      };
    // Update username cases
    case "SET_UPDATE_USERNAME_LOADING":
      return {
        ...state,
        updateUsernameLoading: action.payload,
      };
    case "UPDATE_USERNAME_SUCCESS":
      return {
        ...state,
        updateUsernameLoading: false,
        updateUsernameSuccess: true,
        error: null,
      };
    case "UPDATE_USERNAME_FAILURE":
      return {
        ...state,
        updateUsernameLoading: false,
        error: action.payload,
      };
    case "CLEAR_UPDATE_USERNAME_SUCCESS":
      return {
        ...state,
        updateUsernameSuccess: false,
      };
    // Change My Profile password cases
    case "SET_CHANGE_MYPROFILE_PASSWORD_LOADING":
      return {
        ...state,
        changeMyProfilePasswordLoading: action.payload,
      };
    case "CHANGE_MYPROFILE_PASSWORD_SUCCESS":
      return {
        ...state,
        changeMyProfilePasswordLoading: false,
        changeMyProfilePasswordSuccess: true,
        error: null,
        changeMyProfilePasswordError: null,
      };
    case "CHANGE_MYPROFILE_PASSWORD_FAILURE":
      return {
        ...state,
        changeMyProfilePasswordLoading: false,
        error: action.payload,
        changeMyProfilePasswordError: action.payload,
      };
    case "CLEAR_CHANGE_MYPROFILE_PASSWORD_SUCCESS":
      return {
        ...state,
        changeMyProfilePasswordSuccess: false,
      };
    case "CLEAR_CHANGE_MYPROFILE_PASSWORD_ERROR":
      return {
        ...state,
        changeMyProfilePasswordError: null,
      };
    // Validate current password cases
    case "SET_VALIDATE_CURRENT_PASSWORD_LOADING":
      return {
        ...state,
        validateCurrentPasswordLoading: action.payload,
      };
    case "VALIDATE_CURRENT_PASSWORD_SUCCESS":
      return {
        ...state,
        validateCurrentPasswordLoading: false,
        validateCurrentPasswordError: null,
      };
    case "VALIDATE_CURRENT_PASSWORD_FAILURE":
      return {
        ...state,
        validateCurrentPasswordLoading: false,
        validateCurrentPasswordError: action.payload,
      };
    // Pharmacy stores cases
    case "SET_PHARMACY_STORES_LOADING":
      return {
        ...state,
        pharmacyStoresLoading: action.payload,
      };
    case "GET_PHARMACY_STORES_SUCCESS":
      return {
        ...state,
        pharmacyStores: action.payload,
        pharmacyStoresLoading: false,
        pharmacyStoresError: null,
      };
    case "GET_PHARMACY_STORES_FAILURE":
      return {
        ...state,
        pharmacyStores: [],
        pharmacyStoresLoading: false,
        pharmacyStoresError: action.payload,
      };
    case "CLEAR_PHARMACY_STORES_ERROR":
      return {
        ...state,
        pharmacyStoresError: null,
      };
    // Signature upload cases
    case "SET_SIGNATURE_UPLOAD_LOADING":
      return {
        ...state,
        signatureUploadLoading: action.payload,
      };
    case "UPLOAD_SIGNATURE_SUCCESS":
      return {
        ...state,
        signatureUploadLoading: false,
        signatureUploadError: null,
      };
    case "UPLOAD_SIGNATURE_FAILURE":
      return {
        ...state,
        signatureUploadLoading: false,
        signatureUploadError: action.payload,
      };
    case "CLEAR_SIGNATURE_UPLOAD_ERROR":
      return {
        ...state,
        signatureUploadError: null,
      };
    case "SET_ZENDESK_HELP_CENTER_LOADING":
      return {
        ...state,
        zendeskHelpCenterLoading: action.payload,
      };
    case "GET_ZENDESK_HELP_CENTER_ARTICLES_SUCCESS":
      return {
        ...state,
        zendeskHelpCenterLoading: false,
        zendeskHelpCenterData: action.payload,
        zendeskHelpCenterError: null,
        zendeskHelpCenterFetchAttempted: true,
      };
    case "GET_ZENDESK_HELP_CENTER_ARTICLES_FAILURE":
      return {
        ...state,
        zendeskHelpCenterLoading: false,
        zendeskHelpCenterError: action.payload,
        zendeskHelpCenterFetchAttempted: true,
      };
    case "CLEAR_ZENDESK_HELP_CENTER_ERROR":
      return {
        ...state,
        zendeskHelpCenterError: null,
      };
    case "DELETE_SIGNATURE_SUCCESS":
      return {
        ...state,
        signatureUploadLoading: false,
        signatureUploadError: null,
      };
    case "DELETE_SIGNATURE_FAILURE":
      return {
        ...state,
        signatureUploadLoading: false,
        signatureUploadError: action.payload,
      };
    case "SET_SYSTEM_MAINTENANCE":
      return {
        ...state,
        isSystemMaintenance: !!action.payload,
      };
    default:
      return state;
  }
};

export default usersReducers;
